<template>
  <div class="entrySignApplication">
    <basic-container>
      <avue-crud
        ref="crud"
        :page.sync="page"
        :data="tableData"
        :permission="permissionList"
        :table-loading="tableLoading"
        :option="tableOption"
        v-model="form"
        :key="tableKey"
        @on-load="getPage"
        @refresh-change="refreshChange"
        @sort-change="sortChange"
        @selection-change="handleSelectionChange"
        @search-change="searchChange"
      >
        <template slot="searchMenu" slot-scope="{ row, done }">
          <div class="headerContent">
            <el-button
              size="small"
              plain
              type="primary"
              style="
                margin-bottom: 0;
                background: #fff;
              "
              @click="searchChange(row)"
            >
              筛选
            </el-button>
            <el-button
              size="small"
              v-if="permissions['chain:entrySignApplication:excel']"
              :loading="tableLoading"
              @click="exOut"
            >
              导出
            </el-button>
            <span class="reset" style="margin-left: 14px" @click="reset">
              重置筛选条件
            </span>
          </div>
        </template>
        <template slot="menu" slot-scope="{ row }">
          <el-button
            type="text"
            v-if="permissions['chain:entrySignApplication:view']"
            size="small"
            @click="view(row, 1)"
            >查看</el-button
          >
          <el-button
            type="text"
            v-if="
              permissions['chain:entrySignApplication:audit'] && row.auditAuth
            "
            size="small"
            @click="view(row, 2)"
            >审核</el-button
          >
        </template>
        <template slot="menuLeft" slot-scope="{ size }">
          <div class="menu-left">
            <div class="checked">
              <el-checkbox
                :value="multipleSelection.length > 0"
                @change="changeAll"
                style="margin-right: 8px"
              ></el-checkbox>
              已选<span> {{ multipleSelection.length }} </span>个
            </div>
            <!-- <el-button type="primary" icon="el-icon-download"
              v-if="permissions['chain:entrySignApplication:excel']" size="mini" :loading="tableLoading"
              @click="exOut">导出</el-button> -->
            <el-button
              size="mini"
              v-if="permissions['chain:entrySignApplication:audit']"
              :disabled="multipleSelection.length == 0"
              :loading="tableLoading"
              @click="batchApproval(1)"
            >
              批量通过
            </el-button>
            <el-button
              size="mini"
              v-if="permissions['chain:entrySignApplication:audit']"
              :disabled="multipleSelection.length == 0"
              :loading="tableLoading"
              @click="batchApproval(2)"
            >
              批量驳回
            </el-button>
          </div>
        </template>
      </avue-crud>
    </basic-container>
    <!-- //编辑运单 -->
    <edit-waybill
      v-if="editVisible"
      v-on:searchData="refreshChange"
      :info="info"
      :title="title"
      :row="curRow"
      :visible.sync="editVisible"
    ></edit-waybill>
    <el-dialog
      width="548px"
      :close-on-click-modal="false"
      :visible.sync="checkPassVisible"
    >
      <template slot="title">
        <div class="check-title">
          <i class="el-icon-info" style="color: #35b1ff; margin-right: 8px"></i>
          确定审核{{ auditType == 1 ? "通过" : "驳回" }}吗？
        </div>
      </template>
      <div class="desc-remark">
        已选择 {{ multipleSelection.length }} 个入场签单修改申请，确定审核{{
          auditType == 1 ? "通过" : "驳回"
        }}吗？
      </div>
      <div class="check-remark" v-if="isCheckRemark">
        <div class="check-textarea">
          <textarea
            v-model="auditForm.auditRemark"
            name=""
            id=""
            cols="30"
            rows="5"
            maxlength="100"
            :placeholder="`请输入${auditType == 1 ? '通过' : '驳回'}理由(选填)`"
          ></textarea>
          <div class="num">{{ auditForm.auditRemark.length }}/100</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isCheckRemark = true" v-if="!isCheckRemark"
          >添加备注</el-button
        >
        <el-button @click="checkPassVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPage,
  batchAudit,
  getEntranceDetail,
} from "@/api/chain/entrySignApplication";
import { tableOption } from "@/const/crud/chain/entrySignApplication";
import { mapGetters } from "vuex";
import editWaybill from "./editWaybill.vue";
import { exportOut } from "@/util/down.js";
export default {
  name: "entrySignApplication",
  components: {
    editWaybill,
  },
  data() {
    return {
      tableKey:0,
      auditForm: {
        auditRemark: "",
      },
      isCheckRemark: false,
      textarea: "",
      checkPassVisible: false,
      curRow: {},
      form: {},
      tableData: [],
      page: {
        total: 0, // 总页数
        currentPage: 1, // 当前页数
        pageSize: 20, // 每页显示多少条
        ascs: [], //升序字段
        descs: [], //降序字段
      },
      paramsSearch: {},
      tableLoading: false,
      tableOption: tableOption,
      info: {},
      editVisible: false,
      title: "查看",
      multipleSelection: [],
    };
  },
  created() {
    // this.tableOption.height=this.tableHeight
  },
  mounted: function () {
    const ro = new ResizeObserver(() => {
    this.$nextTick(() => {
      console.info("*****//////////////////")
      this.$refs.crud?.$refs?.table?.doLayout()
    })
  })
  ro.observe(this.$el)
    // this.updateTableHeight(); // 页面加载时计算一次高度
    // window.addEventListener("resize", this.updateTableHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.updateTableHeight); // 清除事件监听
  },
  computed: {
    ...mapGetters(["permissions"]),
    permissionList() {
      return {
        addBtn: this.permissions["chain:entrySignApplication:add"]
          ? true
          : false,
        delBtn: this.permissions["chain:entrySignApplication:del"]
          ? true
          : false,
        editBtn: this.permissions["chain:entrySignApplication:edit"]
          ? true
          : false,
        viewBtn: this.permissions["chain:entrySignApplication:get"]
          ? true
          : false,
      };
    },
  },
  methods: {
    updateTableHeight() {
        // this.tableOption.height= this.$calculateTableHeight(
        //   this.$refs.crud.$refs.table
        // )  
        this.$nextTick(()=>{
          this.$refs.crud.$refs.table.doLayout()
        })
        // this.tableKey += 1
    },
    submit() {
      if (this.auditType == 1) {
        let arr = this.multipleSelection.map((item) => {
          return {
            id: item.id,
            type: item.type,
          };
        });
        let data = {
          list: arr,
          status: 2,
          auditRemark: this.auditForm.auditRemark,
        };
        this.tableLoading = true;
        batchAudit(data)
          .then((res) => {
            this.tableLoading = false;
            this.$message.success("操作成功");
            this.checkPassVisible = false;
            this.getPage(this.page);
          })
          .catch((err) => {
            this.tableLoading = false;
          });
      } else {
        let arr = this.multipleSelection.map((item) => {
          return {
            id: item.id,
            type: item.type,
          };
        });
        let data = {
          list: arr,
          status: 3,
          auditRemark: this.auditForm.auditRemark,
        };
        this.tableLoading = true;
        batchAudit(data)
          .then((res) => {
            this.tableLoading = false;
            this.$message.success("操作成功");
            this.checkPassVisible = false;
            this.getPage(this.page);
          })
          .catch((err) => {
            this.tableLoading = false;
          });
      }
    },
    changeAll(e) {
      if (e) {
        this.$refs.crud.$refs.table.toggleAllSelection();
      } else {
        this.multipleSelection = [];
        this.$refs.crud.$refs.table.clearSelection();
      }
    },
    reset() {
      this.$refs.crud.searchReset();
      // this.searchForm = {};
    },
    searchChange(params, done) {
      params = this.filterForm(params);
      this.paramsSearch = params;
      this.page.currentPage = 1;
      this.getPage(this.page, params);
      // done()
    },
    sortChange(val) {
      let prop = val.prop
        ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase()
        : "";
      if (val.order == "ascending") {
        this.page.descs = [];
        this.page.ascs = prop;
      } else if (val.order == "descending") {
        this.page.ascs = [];
        this.page.descs = prop;
      } else {
        this.page.ascs = [];
        this.page.descs = [];
      }
      this.getPage(this.page);
    },
    getPage(page, params) {
      this.tableLoading = true;
      if (params) {
        if (params.hasOwnProperty("createDatetime")) {
          params.applyDateStart = params.createDatetime[0];
          params.applyDateEnd = params.createDatetime[1];
          delete params.createDatetime;
        }
      }
      getPage(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            descs: this.page.descs,
            ascs: this.page.ascs,
          },
          params,
          this.paramsSearch
        )
      )
        .then((response) => {
          this.tableData = response.data.data.records;
          this.page.total = response.data.data.total;
          this.page.currentPage = page.currentPage;
          this.page.pageSize = page.pageSize;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    /**
     * 刷新回调
     */
    refreshChange(page) {
      this.getPage(this.page);
    },
    view(row, mode) {
      this.curRow = row;
      this.info = JSON.parse(row.entranceWaybillUpdateJson);
      // this.info.companyAuthId = row.companyAuthId
      // this.info.projectInfoId = row.projectInfoId
      this.info.id = row.id;
      // this.info.auditRemark = row.auditRemark
      this.title = mode == 1 ? "查看" : "审核";
      this.info.waybillProjectName = "";
      console.log(this.info);
      this.tableLoading = true;
      getEntranceDetail({ id: row.sourceId, type: row.type })
        .then((res) => {
          let {
            waybillProjectName,
            goDatetime,
            goStaffName,
            ticketImg,
            goPicture,
          } = res.data.data;
          this.info = Object.assign({}, this.info, {
            waybillProjectName,
            goDatetime,
            goStaffName,
            ticketImg,
            goPicture,
          });
          console.log(this.info);
          this.tableLoading = false;
          this.editVisible = true;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    exOut() {
      let params = Object.assign({}, this.paramsSearch);
      if (params) {
        if (params.hasOwnProperty("createDatetime")) {
          params.applyDateStart = params.createDatetime[0];
          params.applyDateEnd = params.createDatetime[1];
          delete params.createDatetime;
        }
      }
      this.tableLoading = true;
      let url =
        "/chain/companyentranceupdatehistory/exportEntranceWorkFlowExcel";
      // params.id = this.info.id
      exportOut(params, url, "入场签单修改申请管理")
        .then(() => {
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchApproval(type) {
      //type1 批量通过  批量驳回
      if (this.multipleSelection.length < 2) {
        this.$message.error("单个审核请在操作区进行逐条审核");
        return false;
      }
      // this.ids = this.multipleSelection.map((item) => item.id).join(",");
      this.auditType = type;
      this.isCheckRemark = false;
      this.checkPassVisible = true;
      this.auditForm = {
        auditRemark: "",
      };
      // if (type == 1) {
      //   this.$prompt("确定对已选择的异常订单进行批量审批通过？", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     inputPlaceholder: "请输入审核备注",
      //     // inputPattern: /\S/,
      //     inputValidator: (value) => {
      //       if (value && value.length > 500) {
      //         return "超出限制字数500";
      //       }
      //     },
      //     inputErrorMessage: "请输入审核备注",
      //   })
      //     .then(({ value }) => {
      //       let arr = this.multipleSelection.map((item) => {
      //         return {
      //           id: item.id,
      //           type: item.type,
      //         };
      //       });
      //       let data = {
      //         list: arr,
      //         status: 2,
      //         auditRemark: value,
      //       };
      //       this.tableLoading = true;
      //       batchAudit(data)
      //         .then((res) => {
      //           this.tableLoading = false;
      //           this.$message.success("操作成功");
      //           this.getPage(this.page);
      //         })
      //         .catch((err) => {
      //           this.tableLoading = false;
      //         });
      //     })
      //     .catch(function (err) {});
      // } else {
      //   this.$prompt("确定对已选择的异常订单进行批量审批驳回？", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     inputPlaceholder: "请输入驳回备注",
      //     inputPattern: /\S/,
      //     inputValidator: (value) => {
      //       if (value && value.length > 500) {
      //         return "超出限制字数500";
      //       }
      //     },
      //     inputErrorMessage: "请输入驳回备注",
      //   })
      //     .then(({ value }) => {
      //       let arr = this.multipleSelection.map((item) => {
      //         return {
      //           id: item.id,
      //           type: item.type,
      //         };
      //       });
      //       let data = {
      //         list: arr,
      //         status: 3,
      //         auditRemark: value,
      //       };
      //       this.tableLoading = true;
      //       batchAudit(data)
      //         .then((res) => {
      //           this.tableLoading = false;
      //           this.$message.success("操作成功");
      //           this.getPage(this.page);
      //         })
      //         .catch((err) => {
      //           this.tableLoading = false;
      //         });
      //     })
      //     .catch(function (err) {});
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/newPage.scss";
.headerContent {
  margin-left: 95px;
}
.menu-left {
  display: flex;
  align-items: center;
  /deep/.el-button {
    margin-bottom: 0;
  }
}
.check-title {
  font-weight: 500;
  font-size: 16px;
  color: #313133;
}
.check-remark {
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid #ededf0;
  padding: 6px 10px;
  .check-textarea {
    position: relative;
    .num {
      position: absolute;
      right: 10px;
      bottom: 15px;
      font-weight: 400;
      font-size: 12px;
      color: #323233;
    }
  }
  textarea {
    border: none;

    margin-right: 30px;
    width: calc(100% - 10px);
    box-sizing: border-box;
  }
}
.desc-remark {
  margin-top: -30px;
  font-weight: 400;
  font-size: 14px;
  color: #626266;
  margin-bottom: 16px;
}
/deep/.el-table {
    .el-table__body-wrapper,
      .el-table__fixed-body-wrapper {
      max-height: calc(100vh - 500px) !important;
      overflow-y: auto;
    }
  }
</style>
